import { formatNok, toVictoryChartFriendlyDataPoint } from '@components/savings-calculator/functions';
import { useInputs } from '@hooks/use-inputs';
import { useCalculatedResults } from '@react-query/hooks/use-calculated-results';
import { VictoryAxis, VictoryBar, VictoryChart, VictoryContainer, VictoryLine, VictoryStack } from 'victory';
import { EikaChartTheme } from './theme';

export const DataChart = () => {
    const { data: calculatedFundSavings } = useCalculatedResults();
    const { compareWithSavingsAccount } = useInputs();

    if (!calculatedFundSavings) {
        return null;
    }

    const { invested, gained } = calculatedFundSavings.expected.chartData;

    return (
        <VictoryChart theme={EikaChartTheme} containerComponent={<VictoryContainer style={{ touchAction: 'pan-y' }} />}>
            <VictoryAxis tickValues={[invested.startTime, invested.endTime]} tickFormat={toFullYear} />
            <VictoryAxis dependentAxis tickFormat={formatNok} />

            <VictoryStack>
                <VictoryBar
                    data={invested.dataPoints.map(toVictoryChartFriendlyDataPoint)}
                    barWidth={8}
                    cornerRadius={{ bottom: 4 }}
                />
                <VictoryBar
                    data={gained.dataPoints.map(toVictoryChartFriendlyDataPoint)}
                    barWidth={8}
                    cornerRadius={{ top: 4 }}
                />
            </VictoryStack>
            {compareWithSavingsAccount && (
                <VictoryLine
                    data={calculatedFundSavings.savingsAccountComparison.chartData.totals.dataPoints.map(
                        toVictoryChartFriendlyDataPoint,
                    )}
                />
            )}
        </VictoryChart>
    );
};

const toFullYear = (unixTimestamp: number) => new Date(unixTimestamp * 1000).getFullYear();
